import axios from "axios";
import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";
import { useAuthStatus } from "./stores/auth-store";
const axiosClient = axios.create();
axiosClient.defaults.baseURL = import.meta.env.VITE_API_URL as string;

export interface DecodedToken {
  sub: string;
  syndicatId?: string;
  exp: number;
  iat: number;
  roles: string[];
  email: string;
}

// Request interceptor for API calls
axiosClient.interceptors.request.use(
  async (config) => {
    let token: string = localStorage.getItem("accessToken") as string;
    if (token) {
      const decodedToken: DecodedToken = jwtDecode(token);
      if (dayjs.unix(decodedToken.exp) < dayjs()) {
        try {
          token = await refreshAccessToken();
        } catch (error) {
          console.log("REFRESH FAILED : REDIRECT TO LOGOUT");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          useAuthStatus.setState({ isLoggedIn: false });
        }
      }
    } else {
      useAuthStatus.setState({ isLoggedIn: false });
    }

    config.headers.set("Authorization", `Bearer ${token ? token : ""}`);
    config.headers.set("Accept", "application/json");
    return config;
  },
  (error) => {
    console.log("REFRESH FAILED : REDIRECT TO LOGOUT");
    useAuthStatus.setState({ isLoggedIn: false });
    Promise.reject(error);
  }
);

export async function refreshAccessToken(): Promise<string> {
  const refreshToken = localStorage.getItem("refreshToken");
  const res = await axios.post(
    `${import.meta.env.VITE_API_URL}/auth/refresh`,
    {},
    {
      headers: {
        Authorization: "Bearer " + refreshToken,
        Accept: "application/json",
      },
    }
  );
  localStorage.setItem("accessToken", res.data.accessToken);
  localStorage.setItem("refreshToken", res.data.refreshToken);
  return res.data.accessToken as string;
}

export const fetcher = (url: string) => axiosClient.get(url).then((res) => res.data);

export default axiosClient;
